import { USERS_ERROR, GET_USER, GET_USERS, CLEAR_USER, UPDATE_USER_STATUS } from '../actions/types';

const initialState = {
  user: null,
  users: [],
  loading: true,
  error: {}
}

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_USER:
      return {
        ...state,
        user: payload,
        loading: false
      }
    case GET_USERS:
      return {
        ...state,
        users: payload,
        loading: false
      }
    case UPDATE_USER_STATUS:
      return {
        ...state,
        users: state.users.map(user =>
          user._id === payload._id ? payload : user
        ),
        loading: false
      }
    case USERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      }
    case CLEAR_USER:
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
}